import {Component, Input} from '@angular/core';

@Component({
    selector: 'app-icon-user-govbr',
    imports: [],
    templateUrl: './icon-user-govbr.component.html',
})
export class IconUserGovbrComponent {
    @Input() height: number = 13;
    @Input() width: number = 15;
}